import React, { Component } from 'react';

class Status extends Component {
  render() {
    let call_agree_date = null;
    if (this.props.client.call_agree_date != null) {
      call_agree_date = new Date(this.props.client.call_agree_date * 1000);
      call_agree_date = call_agree_date.getDate() + '/' + (call_agree_date.getMonth() + 1) + '/' + call_agree_date.getFullYear();
    }

    let sms_agree_date = null;
    if (this.props.client.sms_agree_date != null) {
      sms_agree_date = new Date(this.props.client.sms_agree_date * 1000);
      sms_agree_date = sms_agree_date.getDate() + '/' + (sms_agree_date.getMonth() + 1) + '/' + sms_agree_date.getFullYear();
    }

    let mail_agree_date = null;
    if (this.props.client.mail_agree_date != null) {
      mail_agree_date = new Date(this.props.client.mail_agree_date * 1000);
      mail_agree_date = mail_agree_date.getDate() + '/' + (mail_agree_date.getMonth() + 1) + '/' + mail_agree_date.getFullYear();
    }
    return (
      <div className='card mr-2'>
        <div className='card-body'>
          <h4 className="card-title mb-3">Etat</h4>
          <div className='row h6 text-center'>
            <div className='col'>
              <div className={this.props.client.active == 1 ? 'icon text-green bg-light-green' : 'icon text-blue bg-light-blue'}>
                <li className='fas fa-user '> </li>
              </div>
            </div>
            <div className='col iconTooltip'>
              <div className={this.props.client.call_agree == 1 ? 'icon text-green bg-light-green' : 'icon text-blue bg-light-blue'}>
                <li className='fas fa-phone'> </li>
                {call_agree_date && <span className='iconTooltiptext'>{call_agree_date}</span>}
              </div>
            </div>
            <div className='col iconTooltip'>
              <div className={this.props.client.sms_agree == 1 ? 'icon text-green bg-light-green' : 'icon text-blue bg-light-blue'}>
                <li className='fas fa-comments'> </li>
                {sms_agree_date && <span className='iconTooltiptext'>{sms_agree_date}</span>}
              </div>
            </div>
            <div className='col iconTooltip'>
              <div className={this.props.client.mail_agree == 1 ? 'icon text-green bg-light-green' : 'icon text-blue bg-light-blue'}>
                <li className='fas fa-at'> </li>
                {mail_agree_date && <span className='iconTooltiptext'>{mail_agree_date}</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/Components/Client/Status.js